<script>
import ModelCreate from "../models/create-v2";
import FormsModel from "@/components/forms/customer";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Customers",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('customers.singular')) }},
    resourceRoute: {default: 'customers'},
    modelVariable: {default: 'customer'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('customers.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('customers.plural')),
          href: "/customers",
        },
        {
          text: this.$t("Create New"),
          href: "/customers/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {

      if(value.type?.indexOf('farmer') === -1){
        delete value.farms
      }
      value.addresses = [];
      if((value.type || []).length == 0){
        this.failedAlert({
          message: 'Tipe pelanggan belum dipilih'
        });
        this.storing = false;
        throw new Error('Customer type not selected');
      }
      ['lcs', 'brs', 'processing'].forEach((customer_type) => {
        if(value.type.indexOf(customer_type) !== -1){
          value.addresses.push({
            ...value?.[customer_type],
            type: customer_type,
          })
        }
      });

      return this.$axios
      .post('/customers', value)
      .catch((e) => {
        if (e.response && e.response.data) {
          this.errors = e.response.data.errors;
        }
        throw e
      });
    },
    // store(){
    //   this.$refs.form.tes()
    // }
  }
}
</script>
